import { toRef, computed, createBlock, openBlock, mergeProps, unref, isRef, createSlots, withCtx, createElementBlock, Fragment, renderList, createElementVNode, normalizeClass, toDisplayString, renderSlot } from "vue";
import { useField } from "vee-validate";
import "lodash-es";
import "moment";
import { uuid } from "../../utils/uuid.js";
import { checkRuleExists } from "../../utils/helpers.js";
import { useTheme } from "../../composables/useTheme.js";
import { VRadio } from "vuetify/components/VRadio";
import { VRadioGroup } from "vuetify/components/VRadioGroup";
const _sfc_main = {
  __name: "BanzaRadioGroup",
  props: {
    modelValue: {
      type: [String, Number, Boolean],
      default: null
    },
    rules: {
      type: [String, Array],
      default: ""
    },
    name: {
      type: String,
      default: ""
    },
    items: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      default: ""
    },
    preset: {
      type: String,
      default: null
    }
  },
  setup(__props) {
    const props = __props;
    const { attrs } = useTheme({
      componentKey: "BanzaRadioGroup",
      presetName: toRef(() => props.preset)
    });
    const { value, errorMessage } = useField(
      () => props.name || uuid(),
      toRef(() => props.rules),
      {
        label: props.label,
        syncVModel: true
      }
    );
    const isRequired = computed(() => checkRuleExists(props, "required", false));
    return (_ctx, _cache) => {
      return openBlock(), createBlock(VRadioGroup, mergeProps({
        modelValue: unref(value),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => isRef(value) ? value.value = $event : null),
        name: __props.name,
        "error-messages": unref(errorMessage),
        "hide-details": "auto"
      }, unref(attrs)), createSlots({
        label: withCtx(({ label }) => [
          createElementVNode("span", {
            class: normalizeClass({ required: unref(isRequired) })
          }, toDisplayString(label), 3)
        ]),
        default: withCtx(() => [
          (openBlock(true), createElementBlock(Fragment, null, renderList(__props.items, (item) => {
            return openBlock(), createBlock(VRadio, {
              key: item.id,
              label: item.name,
              value: item.id
            }, null, 8, ["label", "value"]);
          }), 128))
        ]),
        _: 2
      }, [
        renderList(_ctx.$slots, (_, slotName) => {
          return {
            name: slotName,
            fn: withCtx(() => [
              renderSlot(_ctx.$slots, slotName)
            ])
          };
        })
      ]), 1040, ["modelValue", "name", "error-messages"]);
    };
  }
};
export {
  _sfc_main as default
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
